import React from "react";
import { compose, graphql } from "react-apollo";

import { INVENTORY_ENTRIES_QUERY, INVENTORY_ITEMS_QUERY, INVENTORY_QUANTITIES_QUERY } from "views/StockMaterials/stockMaterialsQueries";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import translateErrorMessage from "utils/translateErrorMessage";
import { CLEAR_INVENTORY_LOCATION_QUANTITIES_MUTATION } from "./stockInputMutations";
import StockClearModal from "./StockClearModal";

const StockClear = ({
  clearInventoryLocationQuantities,
  snackbarContext,
  toggleModal,
  isOpen,
}) => {
  const onSubmit = ({ id }) => {
    clearInventoryLocationQuantities({
      variables: { id },
      refetchQueries: [
        { query: INVENTORY_ENTRIES_QUERY },
        { query: INVENTORY_ITEMS_QUERY },
        { query: INVENTORY_QUANTITIES_QUERY },
      ]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Estoque limpo com sucesso.");
        toggleModal();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };
  return (
    <StockClearModal
      title="Limpar local de estoque"
      onSubmit={onSubmit}
      isOpen={isOpen}
      toggleModal={toggleModal}
    />
  );
};

export default compose(
  graphql(CLEAR_INVENTORY_LOCATION_QUANTITIES_MUTATION, { name: "clearInventoryLocationQuantities", }),
  withSnackbarConsumer,
)(StockClear);
